class StockAvailability extends HTMLElement {
  constructor() {
    super();
    this.productContainer = this.closest(".js-product");
    this.cutoffTime = theme.shippingCutoffs?.standard || null;
    this.statusEl = this.querySelector(".gg-stock-availability__status");
    this.dayEl = this.querySelector(".gg-stock-availability__shipping-day");
    this.statuses = {
      in: "In stock",
      out: "Out of stock",
      low: "Low stock",
      pre: "Pre-order"
    }

    setTimeout(() => {
      this.updateAvailabilityAndShippingDay();
    }, 200);

    document.addEventListener("on:variant:change", this.updateAvailabilityAndShippingDay.bind(this));
    document.addEventListener("on:child-variant:change", this.updateAvailabilityAndShippingDay.bind(this));
  }

  isSelectedVariantAStack() {
    const visibleBundleChildren = document.querySelectorAll('.js-bundle-child-wrapper[data-visible="true"]');

    if (visibleBundleChildren.length) {
      let isStack = false;
      
      for (const el of visibleBundleChildren) {
        if (el.dataset.bundleType === 'S') {
          isStack = true;
        }
      }

      return isStack;
    }

    return false
  }

  getPreorderShippingMessage(selectedVariants) {
    if (this.isSelectedVariantAStack()) return null;
    if (!selectedVariants.length) return null;

    
    const dataEl = this.productContainer.querySelector('variant-picker [type="application/json"]');
    const productData = dataEl ? JSON.parse(dataEl.textContent) : null;
    const variantData = productData?.formatted[selectedVariants[0].id];

    return variantData?.preorderShippingMessage || productData?.preorderShippingMessage || null;
  }

  updateAvailabilityAndShippingDay() {
    const selectedVariants = this.getSelectedNonGiftVariants();
    const stockStatus = this.getStockStatus(selectedVariants);
    const shippingDay = this.getShippingDay();
    const preorderMessage = this.getPreorderShippingMessage(selectedVariants);

    this.dataset.status = preorderMessage ? "Pre-order" : stockStatus
    this.statusEl.innerHTML = preorderMessage || stockStatus;
    this.dayEl.innerHTML = stockStatus === this.statuses.out || this.statuses.pre ? "" : ` - Ships ${shippingDay}`;
    this.setAttribute("data-visible", "true");
  }

  getSelectedNonGiftVariants() {
    const variantPicker = this.productContainer.querySelector("variant-picker");
    const bundleChildVariantPickers = this.productContainer.querySelectorAll("bundle-child-variant-picker");
    let selectedVariants = [];
    let selectedStackChildren = [];

    if (bundleChildVariantPickers) {
      bundleChildVariantPickers.forEach(el => {
        if (!el.variant) return;

        const isFree = el.variant.price === 0 || el.data.isFree || el.variant?.name?.toLowerCase().includes("*gift*");
        const variantData = el.data?.formatted ? el.data.formatted[el.variant.id] : null;

        if (!isFree) {
          selectedStackChildren.push({
            available: el.variant.available,
            id: el.variant.id,
            inventoryPolicy: variantData?.inventoryPolicy,
            isFree: false,
            isBundleChild: true,
            isBundleParent: false,
            stockStatus: variantData?.stockStatus || null
          });
        }
      });
    }

    if (variantPicker?.variant) {
      const isBundleParent = variantPicker.dataset.isBundleParent === "true";
      const isStackParent = isBundleParent && selectedStackChildren.length > 0;
      const variantData = variantPicker.data?.formatted ? variantPicker.data.formatted[variantPicker.variant.id] : null;

      selectedVariants.push({
        available: isStackParent || variantPicker.variant.available,
        id: variantPicker.variant.id,
        inventoryPolicy: variantData?.inventoryPolicy,
        isFree: variantPicker.variant.price === 0,
        isBundleChild: false,
        isBundleParent,
        stockStatus: variantData?.stockStatus || null
      });
    }

    let allSelected = selectedVariants.concat(selectedStackChildren);

    // Default variant
    if (!allSelected.length) {
      const blobs = this.productContainer.querySelectorAll('[type="application/json"');

      if (blobs?.length) {
        blobs.forEach(json => {
          const parsed = JSON.parse(json.textContent);
          
          if (parsed.defaultVariant) {
            const variantData = parsed?.formatted ? parsed.formatted[parsed.defaultVariant.id] : null;

            allSelected.push({
              available: parsed.defaultVariant.available,
              id: String(parsed.defaultVariant.id),
              inventoryPolicy: variantData?.inventoryPolicy,
              isFree: parsed.defaultVariant.price < 0.01,
              isBundleChild: false,
              isBundleParent: false,
              stockStatus: variantData?.stockStatus || null
            })
          }
        })
      }
    }

    return allSelected;
  }

  getStockStatus(selectedVariants) {
    const isOutOfStock = selectedVariants.length ? selectedVariants.some(v => {
      const continueSelling = v.inventoryPolicy === 'continue';
      const inStockOnline = v.stockStatus !== this.statuses.out;
      const available = v.available && (inStockOnline || continueSelling);

      if (v.isBundleChild) return !available && !v.isFree;
      
      return !available;
    }) : true;

    // if (preorderShipping) return "Pre-order"
    if (isOutOfStock) return this.statuses.out;
    if (selectedVariants.some(({ isFree, stockStatus }) => !isFree && stockStatus === this.statuses.low)) {
      return this.statuses.low;
    }
    return this.statuses.in;
  }

  getShippingDay() {
    const cutoff = this.cutoffTime || '15:45:00'
    const now = new Date()
    const day = now.getDay()
    const match = cutoff.replace(' ', '').match(/(?<hour>\d+)\W?(?<minute>\d+)?(?<isArvo>pm)?/i)
  
    const cutoffTimeSlices = match
      ? match.groups
      : {
          hour: 15,
          minute: 45,
        }
  
    const cutoffTimeOfToday = new Date(now).setHours(
      parseInt(cutoffTimeSlices.hour) + (cutoffTimeSlices.isArvo ? 12 : 0),
      cutoffTimeSlices.minute || 0,
      0,
      0
    )
  
    if (day % 6 === 0 || (day === 5 && now >= cutoffTimeOfToday)) {
      // Weekends and Fridays after the cutoffTime time.
      return 'next working day'
    }
  
    return now < cutoffTimeOfToday ? 'today' : 'tomorrow'
  }
}

customElements.define('stock-availability', StockAvailability);
